import styled from 'styled-components'
import { Avatar } from '@components/Avatar'
import { backgroundOrange, gold, black, textMuted, border1 } from '@/theme/colors'
import { breakpoints, media } from '@/theme/tokens'
import { fontSizes, text, leading } from '@/theme/typography'
import { Button } from '@components/Button'
import { cardSurface, liftOnHover } from '@components/Card'
import { Pill } from '@components/Pill'


export const LoadingContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
    align-items: center;
    background-color: ${backgroundOrange};
    height: 100%;
`




/** Main CTA — the page's one primary. */
export const AddButton = styled(Button)``

export const AccommodationGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px;

    @media (max-width: ${breakpoints.wide}px) {
        grid-template-columns: repeat(3, 1fr);
    }

    ${media.tabletWide} {
        grid-template-columns: repeat(2, 1fr);
    }

    ${media.phone} {
        grid-template-columns: 1fr;
    }
`

/** A white card on the page ground; the whole card opens the stay, so it lifts on hover. */
export const AccommodationCard = styled.div`
	${cardSurface}
	${liftOnHover}
	padding: 16px 18px;
	height: 152px;
	display: flex;
	flex-direction: column;
	overflow: hidden;

	${media.phone} {
		height: auto;
		min-height: 140px;
		padding: 14px 16px;
	}
`

export const AccommodationName = styled.span`
    font-size: ${fontSizes.base};
    font-weight: 700;
    color: ${black};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: ${leading.snug};
`

export const DateRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 0;
    margin-top: 6px;
    border-top: 1px solid ${border1};
    flex-shrink: 0;
`

export const DateBlock = styled.div<{ $align?: 'left' | 'right' }>`
    display: flex;
    flex-direction: column;
    gap: 1px;
    text-align: ${({ $align }) => $align || 'left'};
`

export const DateLabel = styled.span`
    ${text.eyebrow}
    color: ${gold};
`

export const DateValue = styled.span`
    font-size: ${fontSizes.micro};
    font-weight: 500;
    color: ${black};
`

export const GuestRow = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: auto;
    padding-top: 8px;
    border-top: 1px solid ${border1};
    flex-shrink: 0;
    min-height: 32px;
`

export const AvatarStack = styled.div`
    display: flex;
    align-items: center;
    flex-shrink: 0;
`

/** One face in the passenger / guest stack: overlaps the one before it and sits under it. */
export const StackedAvatar = styled(Avatar)<{ $index: number }>`
    margin-left: ${({ $index }) => ($index > 0 ? '-6px' : '0')};
    z-index: ${({ $index }) => 10 - $index};
`


export const GuestCount = styled.span`
    font-size: ${fontSizes.micro};
    color: ${textMuted};
    font-weight: 500;
    white-space: nowrap;
`

export const YoureAGuestPill = styled(Pill).attrs({ $tone: 'success' as const })`
	margin-left: auto;
	flex-shrink: 0;
`
